// extracted by mini-css-extract-plugin
export var lg = "_ip-7";
export var md = "_ip-6";
export var placeholderContainer = "_ip-1";
export var placeholderIcon = "_ip-2";
export var productImage = "_ip-0";
export var sm = "_ip-5";
export var xl = "_ip-8";
export var xs = "_ip-4";
export var xxs = "_ip-3";